import React, {useContext} from 'react';

import {View, useWindowDimensions} from 'react-native';
import {MicroFrontend} from '@voltmoney/platform';
import {ROUTE, ROUTE_MAP} from '@voltmoney/micro-frontend';
import {WidgetRegistry} from '@voltmoney/component';
import {AppCtx} from '../partnerWeb/configs/appContext';
import {BreakPoints} from '../partnerWeb/configs/util';

const AffiliateSignupPage = ({route}: any) => {
  console.warn('*** AffiliateSignupPage routing params', route.params);
  const {height, width} = useWindowDimensions();
  const AppContext = useContext(AppCtx);
  console.log('affiliate/signup');
  return (
    <AppCtx.Provider value={AppContext}>
      <View
        style={{
          height: width > BreakPoints.WEB ? height : '100%',
          width: '100%',
          flex: 1,
          flexDirection: 'column',
        }}>
        {/*<PartnerHeader />*/}
        {/*/!*@ts-ignore*!/*/}
        {/*<PartnerBody navigation={navigation} route={route} />*/}
        <MicroFrontend
          routeMap={ROUTE_MAP}
          routeCurrent={ROUTE.PARTNER_SIGNUP}
          widgetRegistry={WidgetRegistry}
          extraProps={{
            route: route,
            partnerAccountType: 'AFFILIATE',
          }}
          //@ts-ignore
          width={width}
          height={height}
        />
      </View>
    </AppCtx.Provider>
  );
};
export default AffiliateSignupPage;
